import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { CopyValueDirective } from './copy-value/copy-value.directive';

@NgModule({
  declarations: [
    CopyValueDirective
  ],
  exports: [
    CopyValueDirective
  ],
  imports: [
    FormsModule
  ]
})
export class DirectivesModule {}
